import { Space } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { IconShell } from 'components/atoms/icon-shell';
import { Loading } from 'components/atoms/loading';
import { ProgressPie } from 'components/atoms/progress-pie';
import { HoverHighlight } from 'components/organisms/templates/projects/plan/list-view/status-name-cell/styles';
import { BodyShort01, Text03 } from 'components/styles';
import { AddForm } from './task-table';

const AddTaskOrFormSpace = styled(Space)`
  padding: var(--spacing-02) 0;
`;

const AddTaskPlaceHolder = styled.div`
  ${Text03};
  ${BodyShort01};
  font-weight: var(--font-weight-normal);
  color: var(--blue-60);
  display: flex;
  align-items: center;
  gap: var(--spacing-03);
`;

const AddTaskPaneButton = styled(Button)`
  padding: 0px;
`;

const AddTaskSeparationMessage = styled.div`
  color: var(--gray-40);
`;

interface Props {
  isSubTaskCreating?: boolean;
  showCreateFormPopover: boolean;
  projectId: number;
  onAddNewForm: (name: string, id: number) => Promise<void> | undefined;
  toggleShowAddSubTask: (value: React.SetStateAction<boolean>) => void;

  toggleShowCreateFormPopover: React.Dispatch<React.SetStateAction<boolean>>;
}

export const AddTaskOrFormRow = ({
  isSubTaskCreating,
  showCreateFormPopover,
  projectId,
  onAddNewForm,
  toggleShowAddSubTask,
  toggleShowCreateFormPopover,
}: Props) => {
  if (isSubTaskCreating) {
    return (
      <AddTaskOrFormSpace size={0}>
        <AddTaskPlaceHolder>
          <HoverHighlight>
            <IconShell icon={<ProgressPie progress={0} />} />
            <Loading />
          </HoverHighlight>
        </AddTaskPlaceHolder>
      </AddTaskOrFormSpace>
    );
  }

  return (
    <AddTaskOrFormSpace size={0}>
      <AddTaskPlaceHolder>
        <HoverHighlight>
          <IconShell icon={<ProgressPie progress={0} />} />
          <AddTaskPaneButton
            size="small"
            type="link"
            data-cy="templates.list.add_task"
            onClick={() => toggleShowAddSubTask(true)}
          >
            <FormattedMessage id="templates.list.add_task" />
          </AddTaskPaneButton>
        </HoverHighlight>
        <AddTaskSeparationMessage>
          <FormattedMessage id="or" />
        </AddTaskSeparationMessage>
        <HoverHighlight>
          <AddTaskPaneButton
            data-cy="templates.list.add_form"
            size="small"
            type="link"
            onClick={(e) => {
              toggleShowCreateFormPopover(true);
              e.stopPropagation();
            }}
          >
            <FormattedMessage id="forms.response.add_form" />
          </AddTaskPaneButton>
        </HoverHighlight>
      </AddTaskPlaceHolder>
      <AddForm
        showCreateFormPopover={showCreateFormPopover}
        projectId={projectId}
        onAddNewForm={onAddNewForm}
        toggleShowCreateFormPopover={toggleShowCreateFormPopover}
      />
    </AddTaskOrFormSpace>
  );
};
